import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import CoreButton from 'frontcore/components/CoreButton.vue'
import i18n from 'frontcore/i18n'
import { AuthorizationSAMLUseCaseFactory } from 'frontcore/domain/authorization/factory'
import { computed, onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'

type Props = {
  applicationId?: string
  isFetchingUserConfiguration: boolean
}
type Emits = {
  (e: 'error', message: string): void,
  (e: 'loginSuccess'): void,
}

const __default__ = {
  name: 'AuthorizationSAML',
  inheritAttrs: false,
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    applicationId: {},
    isFetchingUserConfiguration: { type: Boolean }
  },
  emits: ["error", "loginSuccess"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const route = useRoute()

const { t } = i18n.global

onMounted(async () => {
  if (route.query.logout === 'true') {
    logoutHandler()
  } else {
    await loginHandler()
  }
})

const logoutHandler = () => {
  if (typeof ENV_PUBLIC_PATH !== 'undefined' ) {
    window.location.href = ENV_PUBLIC_PATH
  } else {
    window.location.href = '/'
  }
}

const { login, continueLoginProcess } = AuthorizationSAMLUseCaseFactory.build()

const isLoading = ref<boolean>(false)
const loginHandler = async () => {
  const requestId = route.query.request_id ?? null
  if (requestId === null) { return }
  isLoading.value = true
  try {
    await continueLoginProcess(requestId.toString(), props.applicationId)
    emit('loginSuccess')
  } catch (error: unknown) {
    if (error instanceof Error) {
      emit('error', error.message)
    }
    isLoading.value = false
  }
}

const isLoginButtonLoading = computed<boolean>(() => {
  return isLoading.value || (isLoading.value && props.isFetchingUserConfiguration)
})

watch(
  () => props.isFetchingUserConfiguration,
  (newValue, oldValue) => {
    if (newValue || newValue === oldValue) { return }
    isLoading.value = newValue
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CoreButton, {
    disabled: _ctx.isFetchingUserConfiguration,
    label: _unref(t)('login.messages.corporate_title', { corporate_title: 'SAML' }),
    loading: isLoginButtonLoading.value,
    buttonType: "secondary",
    dataTest: "authorization-saml-login-button",
    type: "submit",
    onClick: _unref(login)
  }, null, 8, ["disabled", "label", "loading", "onClick"]))
}
}

})